/** The thread's Export menu, next to Share: copy / download the whole
 *  conversation as Markdown. (`extraItems` lets the PDF export join without
 *  this file knowing about it.) */
import IosShareIcon from '@mui/icons-material/IosShare';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState, type ReactNode } from 'react';

import { useSnackbar } from '@/components/Snackbar';
import { downloadText } from '@/utils/download';

export function ExportMenu({
  markdown,
  filename,
  extraItems,
}: {
  /** Built lazily — only when an item is chosen. */
  markdown: () => string;
  filename: () => string;
  extraItems?: (close: () => void) => ReactNode;
}) {
  const snackbar = useSnackbar();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const close = () => setAnchor(null);

  return (
    <>
      <Button
        size="small"
        startIcon={<IosShareIcon fontSize="small" />}
        aria-haspopup="menu"
        aria-expanded={anchor ? 'true' : undefined}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        Export
      </Button>
      <Menu anchorEl={anchor} open={anchor != null} onClose={close}>
        <MenuItem
          onClick={() => {
            close();
            navigator.clipboard.writeText(markdown()).then(
              () => snackbar.show('The diagnosis was copied as Markdown.', 'success'),
              () => snackbar.show('Could not copy to the clipboard.', 'error'),
            );
          }}
        >
          Copy as Markdown
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            downloadText(markdown(), filename(), 'text/markdown');
          }}
        >
          Download Markdown (.md)
        </MenuItem>
        {extraItems?.(close)}
      </Menu>
    </>
  );
}
